import { apiFetch } from "../utils/api";
import { idToken } from "./authService";

export interface DiscountConfigurationRow {
  id: number;
  company_id: number | null;
  [key: string]: string | number | boolean | null | undefined;
}

export interface DiscountConfigurationMeta {
  total: number;
  page: number;
  perPage: number;
}

export interface DiscountConfigurationFilters {
  search: string;
  companyId: string;
}

export interface CompanySummary {
  id: number;
  code: string;
  name: string;
}

async function token() {
  return await idToken();
}

export async function fetchDiscountConfigurations(
  page: number,
  perPage: number,
  filters: DiscountConfigurationFilters
): Promise<{ data: DiscountConfigurationRow[]; meta: DiscountConfigurationMeta }> {
  const t = await token();
  const q = new URLSearchParams({ page: String(page), perPage: String(perPage) });
  if (filters.search) q.set("search", filters.search);
  if (filters.companyId) q.set("companyId", filters.companyId);

  return apiFetch(t, `/api/discount_configurations/admin_index?${q}`);
}

export async function fetchAllCompanies(): Promise<CompanySummary[]> {
  const t = await token();
  const res = await apiFetch(t, `/api/companies/all`);
  return res.items ?? [];
}
